import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocal from 'element-ui/lib/locale';
import messages from "./langs/index"


Vue.use(VueI18n);
 

// 实现自定义格式
class CustomFormatter {
	constructor (options) {
 
	}
	upperCase(text) {  
	   if (text === undefined || text === null) {  
		 console.error('Text is undefined or null');  
		 return '';  
	   }  
	   return text.replace(/\b([\w|']+)\b/g, (result) => {  
		 let lowText = result.toLowerCase();  
		 return lowText.charAt(0).toUpperCase() + lowText.slice(1);  
	   });  
	 }  
	 
	 interpolate(message, values) {  
	   // 确保 values 是一个对象，如果不是，则使用空对象代替  
	   values = values || {};  
	   
	   if (message === undefined || message === null) {  
		 console.error('Message is undefined or null');  
		 return [''];  
	   }  
	   
	   // 替换消息中的占位符为对应的值  
	   Object.keys(values).forEach(key => {  
		 if (values[key] !== undefined && values[key] !== null) {  
		   message = message.replace(`{${key}}`, values[key]);  
		 }  
	   });  
	   
	   // 返回处理后的消息  
	  //  return [this.upperCase(message)];  
	   return [message];  
	 }
 }
 
const i18n = new VueI18n({
	locale: sessionStorage.getItem('Select-Language') || 'zh',
	formatter: new CustomFormatter(),
	messages,
});

const language = sessionStorage.getItem('Select-Language') || 'zh';
if(language == 'en'){
   i18n.locale = 'en';
}
// i18n.locale = 'en';
//element
ElementLocal.i18n((key, value) => i18n.t(key, value));

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js